<template>
  <div class="classes-details">
    <div class="classes-main">
      <div class="classes-inner">
        <div
          class="classes-list fn-clear"
          :style="{ width: `${classesList.length * 240}px` }"
        >
          <div
            v-for="item in classesList"
            :key="item.id"
            class="classes-item fn-left"
          >
            <div class="date-time">
              <div class="classes-date">
                {{ item.create_time.substr(0, 11) }}
              </div>
              <div class="classes-time">{{ item.create_time.substr(11) }}</div>
            </div>
            <div
              v-if="item.action == 'ask_for_suspension'"
              class="classes-content"
            >
              <p>停课发起人：{{ item.editor_name }}</p>
              <p>停课原因：{{ item.remark }}</p>
              <p>
                停课状态：{{
                  item.audit_status == 0
                    ? "待审核"
                    : item.audit_status == 1
                      ? "审核成功"
                      : "审核失败"
                }}
              </p>
              <p>停课日期：{{ item.start_date }}</p>
            </div>
            <div v-else class="classes-content">
              <p>复课发起人：{{ item.editor_name }}</p>
              <p>复课原因：{{ item.remark }}</p>
              <p>
                复课状态：{{
                  item.audit_status == 0
                    ? "待审核"
                    : item.audit_status == 1
                      ? "审核成功"
                      : "审核失败"
                }}
              </p>
              <p>复课日期：{{ item.start_date }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ClassesDetials',
  components: {},
  data() {
    return {
      filterObj: {
        start_time: '',
        end_time: ''
      },
      classesList: []
    }
  },
  computed: {},
  watch: {},
  mounted() {
    const child_id = this.$route.query.child_id
    this.getInfoAskForLeave(child_id)
  },
  methods: {
    async getInfoAskForLeave(child_id) {
      const ret = await this.$http.getInfoAskForLeave({ child_id })
      if (ret.code == 200) {
        this.classesList = ret.data.list
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.classes-details {
  .classes-main {
    border-radius: 10px;
    border: solid 1px #d9d9d9;
    box-sizing: border-box;
    padding: 40px 30px;
    .classes-inner {
      overflow: auto;
      .classes-list {
        .classes-item {
          width: 240px;
          color: $color_black;
          font-size: 14px;
          .date-time {
            padding: 0 0 20px 30px;
            border-bottom: solid 4px $color_blue;
            position: relative;
            &:before {
              content: "";
              position: absolute;
              width: 18px;
              height: 18px;
              border-radius: 50%;
              background-color: rgba(76, 132, 255, 0.2);
              left: 27px;
              bottom: -11px;
            }
            &:after {
              content: "";
              position: absolute;
              width: 12px;
              height: 12px;
              border-radius: 50%;
              background-color: $color_blue;
              left: 30px;
              bottom: -8px;
            }
          }
          .classes-content {
            margin: 15px 0 30px 30px;
            width: 210px;
            border-radius: 6px;
            background-color: rgba(76, 132, 255, 0.1);
            box-sizing: border-box;
            padding: 10px;
            p {
              margin-bottom: 10px;
            }
          }
        }
      }
    }
  }
}
</style>
